/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DomainMappingDto } from './DomainMappingDto';
import {
    DomainMappingDtoFromJSON,
    DomainMappingDtoFromJSONTyped,
    DomainMappingDtoToJSON,
    DomainMappingDtoToJSONTyped,
} from './DomainMappingDto';

/**
 * 
 * @export
 * @interface BulkCustomerDomainsGroupedResponse
 */
export interface BulkCustomerDomainsGroupedResponse {
    /**
     * 
     * @type {{ [key: string]: Array<DomainMappingDto>; }}
     * @memberof BulkCustomerDomainsGroupedResponse
     */
    dataByCustomerId?: { [key: string]: Array<DomainMappingDto>; };
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof BulkCustomerDomainsGroupedResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof BulkCustomerDomainsGroupedResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the BulkCustomerDomainsGroupedResponse interface.
 */
export function instanceOfBulkCustomerDomainsGroupedResponse(value: object): value is BulkCustomerDomainsGroupedResponse {
    return true;
}

export function BulkCustomerDomainsGroupedResponseFromJSON(json: any): BulkCustomerDomainsGroupedResponse {
    return BulkCustomerDomainsGroupedResponseFromJSONTyped(json, false);
}

export function BulkCustomerDomainsGroupedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCustomerDomainsGroupedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dataByCustomerId': json['dataByCustomerId'] == null ? undefined : json['dataByCustomerId'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function BulkCustomerDomainsGroupedResponseToJSON(json: any): BulkCustomerDomainsGroupedResponse {
    return BulkCustomerDomainsGroupedResponseToJSONTyped(json, false);
}

export function BulkCustomerDomainsGroupedResponseToJSONTyped(value?: BulkCustomerDomainsGroupedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dataByCustomerId': value['dataByCustomerId'],
        'success': value['success'],
        'error': value['error'],
    };
}

